import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { useContent } from "@/context/ContentContext";

export default function Layout() {
  const { content } = useContent();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main id="main" className="flex-1">
        {content ? <Outlet /> : <div className="min-h-[70vh]" aria-busy="true" data-testid="page-loading" />}
      </main>
      {content && <Footer content={content} />}
    </div>
  );
}
